<template>
  <div class="qr-container">
    <div class="scanner-wrapper">
      <qrcode-stream
        v-if="!decodedResult"
        @decode="onDecode"
        @init="onInit"
        @error="onError"
        :key="scannerKey"
      />
    </div>

    <button   @click="scanAgain" class="btn btn-primary mt-2">
      Scan Again
    </button>

    <div v-if="decodedResult" class="result-box">
      <strong>Decoded Result:</strong> {{ decodedResult }}
    </div>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue3-qrcode-reader';

export default {
  components: {
    QrcodeStream
  },
  data() {
    return {
      decodedResult: null,
      scannerKey: 0 
    };
  },
  methods: {
    onDecode(decodedString) {
      this.decodedResult = decodedString;

      // Optional: validate before redirecting
      if (decodedString.startsWith("http")) {
          
        setTimeout(() => {
            window.location.replace(decodedString);
        //   window.location.href = decodedString;
        }, 300);
      } else {
        alert("Invalid QR code content: " + decodedString);
      }
    },
    onInit(promise) {
      promise
        .then(() => {
          console.log("QR code reader initialized");
        })
        .catch((error) => {
          console.error("QR code reader initialization failed", error);
        });
    },
    onError(error) {
      console.error("Error reading QR code", error);
    },
    scanAgain() {
       this.decodedResult = null;
         this.scannerKey++; // Force re-render to restart camera
    }
  }
};
</script>

<style scoped>
video {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
}

.qr-container {
  max-width: 500px;
  margin: 2rem auto;
  padding: 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  background-color: #f9f9f9;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.scanner-wrapper {
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  border-radius: 8px;
  background: #000;
}

.result-box {
  margin-top: 1rem;
  padding: 0.8rem;
  background-color: #e8f5e9;
  border: 1px solid #c8e6c9;
  border-radius: 8px;
  font-size: 1rem;
  color: #2e7d32;
  word-wrap: break-word;
}
</style>
